<template>
  <div class="publishers-section">
    <h3 class="tab-title px-10 my-8 mb-0">Publishers</h3>
    <p class="publishers-desc px-10 my-5">
      You can check your targeted websites, enable or block any of them.
    </p>

    <vue-tabs ref="subTabsContainer" v-model="activeTab">
      <v-tab key="websites" tabKey="websites">
        <div slot="title">
          <h4 class="publishers-tabs-title align-middle font-light py-3 px-5">
            {{ $t("Websites") }}
          </h4>
        </div>

        <div class="p-6 mt-2" v-if="activeTab === 'websites'">
          <DomainsTargetingTable :type="'websites'" />
        </div>
      </v-tab>

      <v-tab key="apps" tabKey="apps">
        <div slot="title">
          <h4 class="publishers-tabs-title align-middle font-light py-3 px-5">
            {{ $t("Mobile Apps") }}
          </h4>
        </div>

        <div class="p-6 mt-2" v-if="activeTab === 'apps'">
          <DomainsTargetingTable :type="'apps'" />
        </div>
      </v-tab>
    </vue-tabs>
  </div>
</template>


<script>
import { VueTabs, VTab } from '@/components/vue-nav-tabs/vue-nav-tabs.js'
import DomainsTargetingTable from './_publishers_partials/DomainsTargetingTable.vue'

export default {
  components: {
    VueTabs,
    VTab,
    DomainsTargetingTable
  },
  data () {
    return {
      activeTab: 'websites'
    }
  },
  mounted () {
    if (this.$refs.subTabsContainer) {
      this.$refs.subTabsContainer.activateTab(0)
    }
  }
}
</script>


<style lang="scss">

  .tab-title {
    font-size: 24px;
  }

  .publishers-tabs-title {
    font-size: 16px;
  }

  .tab.active h4 {
    color: #0092d7;
  }

  [dir] .vue-tabs .nav > li > a:hover,
  [dir] .vue-tabs .nav > li > a:focus {
    background-color: transparent !important;
  }

  .ag-theme-alpine .ag-checkbox-input-wrapper:focus-within,
  .ag-theme-alpine .ag-checkbox-input-wrapper:active {
    box-shadow: none !important;
  }

  .tab.active h4 {
    font-weight: 400;
  }

  .publishers-section {
    .ag-center-cols-container {
      width: 100% !important;
      overflow: hidden;
    }

    .nav-tabs {
      padding-left: 35px;
    }

    .publishers-desc {
      color: #999;
      margin-top: 12px !important;
    }

    .active_tab {
      h4 {
        font-weight: 400 !important;
      }
    }
  }

  @media (max-width: 576px) {
    .publishers-section {
      .nav-tabs {
        padding-left: 0;
      }

      .tab-title {
        font-size: 18px;
      }

      .publishers-desc {
        font-size: 14px;
      }

      .publishers-tabs-title {
        font-size: 14px;
      }
    }
  }
</style>
